import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../services/API";

export const getHashtag = createAsyncThunk("getHashtag", async ({ hashtag, page = 1, append = false }) => {
  try {
    const url = `post/trends/${hashtag}/?page=${page}`;
    const response = await axiosInstance.get(url);
    const result = response.data;
    return { ...result, append, currentPage: page };
  } catch (error) {
    console.error("Error:", error.response?.data);
    throw error;
  }
});

export const HashTagSlice = createSlice({
  name: "HashTag",
  initialState: {
    hashTagList: { results: [], count: 0, next: null, previous: null },
    loading: false,
    loadingMore: false,
    error: null,
    hasMore: true,
    currentPage: 1,
  },
  reducers: {
    resetHashtagState: (state) => {
      state.hashTagList = { results: [], count: 0, next: null, previous: null };
      state.currentPage = 1;
      state.hasMore = true;
      state.loadingMore = false;
    }
  },
  extraReducers: (builder) => {
    // getHashtag action promises
    builder.addCase(getHashtag.pending, (state, action) => {
      if (action.meta.arg.append) {
        state.loadingMore = true;
      } else {
        state.loading = true;
      }
    });
    builder.addCase(getHashtag.fulfilled, (state, action) => {
      state.loading = false;
      state.loadingMore = false;
      state.error = null;

      const payload = action.payload;

      if (action.meta.arg.append && payload.append) {
        // Append new results to existing ones
        state.hashTagList.results = [
          ...state.hashTagList.results,
          ...(payload.results || [])
        ];
        // Update current page for next load
        state.currentPage = payload.currentPage;
        // Update the hashTagList next property
        state.hashTagList.next = payload.next;
      } else {
        // Replace with new results (fresh load)
        state.hashTagList = payload;
        state.currentPage = payload.currentPage || 1;
      }

      // Update pagination state - only continue if there's a next URL
      state.hasMore = !!payload.next;
    });
    builder.addCase(getHashtag.rejected, (state, action) => {
      state.loading = false;
      state.loadingMore = false;
      state.error = action.payload;
    });
  },
});

export const { resetHashtagState } = HashTagSlice.actions;
export default HashTagSlice.reducer;